import React, { FC, useState, useContext, useEffect } from 'react'
import { BookingFormValues } from './booking/Booking'

type Tour = {
  codename: string | null
  persons: number | null
  time: string | null
  date: string | null
  mode: string | null
  language: string | null
}
type State = {
  isLoaded: boolean
  values: BookingFormValues | null
  tour: Tour
}

type Methods = {
  setTour: (tour: Tour) => void
  setValues: (values: BookingFormValues) => void
  clear: () => void
}

const initialState: State = {
  isLoaded: false,
  values: null,
  tour: {
    codename: null,
    mode: null,
    persons: null,
    time: null,
    date: null,
    language: null
  }
}

const TourBookingContext = React.createContext<State & Methods>({
  ...initialState,
  setTour: () => {},
  setValues: () => {},
  clear: () => {}
})

export const TourBookingProvider: FC<{}> = ({ children }) => {
  const [state, setState] = useState<State>(initialState)

  const setTour = (tour: Tour) => {
    window.sessionStorage.setItem(
      'tour_booking',
      JSON.stringify({ ...state, isLoaded: undefined, tour })
    )
    setState(s => ({ ...s, tour }))
  }

  const setValues = (values: BookingFormValues) => {
    window.sessionStorage.setItem(
      'tour_booking',
      JSON.stringify({ ...state, isLoaded: undefined, values })
    )
    setState(s => ({ ...s, values }))
  }
  const clear = () => setState({ ...initialState })

  useEffect(() => {
    const booking = window.sessionStorage.getItem('tour_booking')
    if (booking) {
      setState({ isLoaded: true, ...JSON.parse(booking) })
    } else {
      setState(s => ({ ...s, isLoaded: true }))
    }
  }, [])

  return (
    <TourBookingContext.Provider value={{ ...state, setTour, setValues, clear }}>
      {children}
    </TourBookingContext.Provider>
  )
}

export function useTourBookingContext() {
  const ctx = useContext(TourBookingContext)
  if (typeof ctx === 'undefined') {
    throw new Error('Can only use checkout context within a TourBookingContext Provider')
  }
  return ctx
}
